import React from "react";
import { Box, Typography } from "@mui/material";
import DynamicTable from "./DynamicTable";
import DynamicCards from "./DynamicCards";
import RankingView from "./RankingView";
import EmployeeView from "./EmployeeView";
import LeaveView from "./LeaveView";
import JobOfferView from "./JobOfferView";
import CandidateView from "./CandidateView";
import ClarificationMessage from "./ClarificationMessage";
import ErrorMessage from "./ErrorMessage";

const MessageRenderer = ({ answer, displayType, data, title }) => {
  
  const shouldFilterText = (text) => {
    if (!text || typeof text !== 'string') return true;
    const lowerText = text.toLowerCase().trim();
    const exactMatches = [
      "leave list",
      "employee count",
      "job offer count",
      "clarification query"
    ];
    return exactMatches.some(match => lowerText === match);
  };

  const renderText = (text) => {
    if (shouldFilterText(text)) return null;
    return (
      <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6, '& p': { m: 0, mb: 1.5 } }}>
        {text}
      </Typography>
    );
  };

  const renderContent = () => {
    switch (displayType) {
      case "table":
        return <DynamicTable data={data} title={title} />;
      case "cards":
        return <DynamicCards data={data} title={title} />;
      case "ranking":
        return <RankingView data={data} />;
      case "employee":
        return <EmployeeView data={data} />;
      case "leave":
        return <LeaveView data={data} />;
      case "job_offer":
        return <JobOfferView data={data} />;
      case "candidate":
        return <CandidateView data={data} />;
      case "list":
        return (
          <Box>
            {renderText(answer)}
          </Box>
        );
      case "error":
        return <ErrorMessage error={answer} />;
      case "clarification":
        return <ClarificationMessage message={answer} />;
      case "dashboard":
        // For dashboard type, render cards if data is an array
        if (Array.isArray(data) && data.length > 0) {
          return <DynamicCards data={data} title={title} />;
        }
        return (
          <Box>
            {renderText(answer)}
          </Box>
        );
      default:
        return (
          <Box>
            {renderText(answer)}
          </Box>
        );
    }
  };

  return (
    <Box className="message-content">
      {answer && typeof answer === 'string' && !displayType && !shouldFilterText(answer) && (
        <Box sx={{ mb: 2 }}>
          {renderText(answer)}
        </Box>
      )}
      {renderContent()}
    </Box>
  );
};

export default MessageRenderer;
